export default __webpack_public_path__ + "static/media/pictogramBeaconCertificateEducation40.fcb1267c.svg";